const timeMap: {[label: string]: number} = {}

export const time = (label: string) => {
  timeMap[label] = performance.now()
}

export const timeEnd = (label: string): { elapsedTimeMillis: number} | { noLabel: {} } => {
  if (label in timeMap) {
    const elapsedTimeMillis = performance.now() - timeMap[label]
    delete timeMap[label]
    return { elapsedTimeMillis }
  }
  return { noLabel: {} }
}
